View = require 'view'
templates = require 'views/internal/templates'

module.exports = class ShortcutsView extends View
  render: ->
    @$el.html(templates.fill('shortcuts'))

    @


// WEBPACK FOOTER //
// ./app/scripts/views/shortcuts/shortcuts-view.coffee